import React, { useContext } from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { Spotlight } from '@components/Spotlight'
import Box from '@material-ui/core/Box'

import { AssetsContext } from '../../context'

import { R } from '@utils/currency'

export const AssetTotals = () => {
  const { state } = useContext(AssetsContext)
  const { totalContributions, totalCapital } = state

  const mobile = useMediaQuery('(max-width:475px)')
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      className='asset-totals px-8 my-4 mm:px-12'
    >
      <Spotlight
        value={R(totalCapital).format()}
        description={`Total Capital`} />
      <Spotlight
        value={R(totalContributions).format()}
        description={mobile ? 'Monthly Contributions' : 'Total Monthly Contributions'} />
    </Box>
  )
}
